import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import apiFetch from '../../../utils/apiFetch';
import { notify } from '../../../utils/notification';
import { targetingBlock } from '../../../shared/rules/effects/buffModifiers.mjs';

let ask = null;

/** Before an attack or targeted spell: throws, like a range refusal, when this target can't be chosen. */
export const passTargetingBlock = async ({ campaignId, combatState, attackerId, targetId, targetName, onCombatChange }) => {
  const block = targetingBlock(combatState, attackerId, targetId);
  if (!block) return;
  if (block.kind !== 'ward' || block.failed) throw new Error(block.message);
  await new Promise(resolve => (ask ? ask({ targetName, dc: block.effect.saveDc, resolve }) : resolve()));
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/buffs/ward-save`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: `ward-save:${block.effect.id}:${attackerId}:${combatState.turnSequence}`, attackerId: String(attackerId), targetId: String(targetId) }) });
  const result = await response.json();
  if (!response.ok) throw new Error(result.message || 'The save could not be made.');
  onCombatChange?.(result.combat);
  if (!result.success) throw new Error(`Sanctuary: ${result.total} against DC ${result.dc}. Choose a new target.`);
  notify(`Sanctuary: ${result.total} against DC ${result.dc}. The attack goes ahead.`, 'success');
};

// Sanctuary: comes up for whoever controls the attacker, the player or the DM.
export default function WardSavePrompt() {
  const [request, setRequest] = useState(null);
  useEffect(() => { ask = setRequest; return () => { ask = null; }; }, []);
  if (!request) return null;
  return <Modal show centered backdrop="static" keyboard={false} className="dnd-modal modern-modal" aria-label="Sanctuary">
    <Modal.Header><Modal.Title>Sanctuary</Modal.Title></Modal.Header>
    <Modal.Body><p>{request.targetName || 'This creature'} is warded. Make a Wisdom save (DC {request.dc}) to go on, or choose a new target.</p></Modal.Body>
    <Modal.Footer><Button onClick={() => { request.resolve(); setRequest(null); }}>Roll the save</Button></Modal.Footer>
  </Modal>;
}
